<template>
  <container :class="[baseCss]" v-if="documentation && !hidden">
    <card :overflow-off="false">
      <card-text>
        <toolbar :class="['mb-4']" color="color" :color-lightness="colorLightness" :dense="dense" bg-color="transparent" :bg-color-lightness="null">
          <toolbar-icon>
            <icon :name="icon" :color="bgColor" :color-lightness="bgColorLightness" />
          </toolbar-icon>
          <toolbar-title :text="title" />
          <toolbar-actions v-if="selected && this.dropdown.length > 1" width="240px">
            <dropdown :color="bgColor" :color-lightness="bgColorLightness" v-model="selected" :items="dropdown" />
          </toolbar-actions>
        </toolbar>
        <tab v-if="selected" padding-off :height="tabHeight" :name="name" :dense="dense" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" :color="color" :color-lightness="colorLightness">
          <tab-panel v-for="(panel, index) in tabs" :key="index" :label="panel.label" :icon="panel.icon">
            <alert type="success" v-if="!documentation[selected[0]][panel.label]" v-model="alert" :class="['mt-2']" :dismissible="false">{{ noDocumentation }}</alert>
            <api-explorer-doc-table v-if="documentation[selected[0]][panel.label]" :th="rows[panel.label]" :td="documentation[selected[0]][panel.label]" />
          </tab-panel>
        </tab>
      </card-text>
    </card>
  </container>
</template>
<script>
import methods from '../../mixins/methods'
import ApiExplorerDocTable from './api-explorer-doc-table'

export default {
  name: 'ApiExplorer',
  components: {
    ApiExplorerDocTable
  },
  mixins: [
    methods
  ],
  data () {
    return {
      alert: true,
      hidden: true,
      documentation: null,
      dropdown: [],
      selected: null,
      baseCss: this.componentBaseCss('api-explorer', [])
    }
  },
  props: {
    rows: {
      type: Object,
      default: () => {
        return {
          props: ['name', 'type', 'required', 'default', 'description'],
          slots: ['name', 'description'],
          events: ['event', 'return value', 'description']
        }
      }
    },
    tabs: {
      type: Array,
      default: () => [{
        label: 'props',
        icon: 'code-tags'
      }, {
        label: 'slots',
        icon: 'application'
      }, {
        label: 'events',
        icon: 'database'
      }]
    },
    tabHeight: {
      type: String
    },
    noDocumentation: {
      type: String,
      default: 'No documentation available for this view.'
    },
    name: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'view-dashboard'
    },
    title: {
      type: [Number, String],
      default: 'Documentation'
    },
    dense: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String
    },
    bgColorLightness: {
      type: Number
    },
    color: {
      type: String,
      default: 'black'
    },
    colorLightness: {
      type: [String, Number],
      default: null
    }
  },
  watch: {
    $route () {
      this.hidden = true
      this.documentation = null
    }
  },
  created () {
    this.onCreated()
  },
  methods: {
    onCreated () {
      this.bind()
    },
    bind () {
      this.$root.$on('documentation', (documentation) => {
        if (!documentation) {
          this.hidden = true
          this.documentation = null
          return
        }
        this.documentation = documentation
        this.$nextTick(() => {
          this.dropdown = Object.keys(this.documentation).map(text => {
            return {text, value: text}
          })
          this.selected = [this.dropdown[0].value]
          this.hidden = false
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/api-explorer/api-explorer.vue